import {
  DASHBOARD_LOAD_REQUEST,
  DASHBOARD_LOAD_SUCCESS,
  DASHBOARD_LOAD_ERROR
} from "./actions";

const initialState = {
  data: null,
  loading: false,
  error: null,
  lastUpdated: null
};

export default function dashboardReducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case DASHBOARD_LOAD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case DASHBOARD_LOAD_SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
        error: null,
        lastUpdated: new Date().toISOString()
      };

    case DASHBOARD_LOAD_ERROR:
      return {
        ...state,
        loading: false,
        error: payload
      };

    default:
      return state;
  }
}
